import { render } from "./Choice.vue?vue&type=template&id=9ebfd6c4&scoped=true"
import script from "./Choice.vue?vue&type=script&lang=js"
export * from "./Choice.vue?vue&type=script&lang=js"

import "./Choice.vue?vue&type=style&index=0&id=9ebfd6c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebfd6c4"]])

export default __exports__